"use strict";
exports.__esModule = true;
exports.inavVersionData = {
    productType: 'inav',
    versions: [
        {
            version: '1.0.0',
            apiVersion: '5.15.0',
            title: '',
            date: 'Jun 05, 2025',
            showDate: true,
            logs: [
                'Initial Release.'
            ]
        }
    ]
};
//# sourceMappingURL=inav-version.js.map


// WEBPACK FOOTER //
// ./app/inav-version.js